import script from "./Orbital.vue?vue&type=script&setup=true&lang=js"
export * from "./Orbital.vue?vue&type=script&setup=true&lang=js"

import "./Orbital.vue?vue&type=style&index=0&id=0afb3d7c&lang=css"

const __exports__ = script;

export default __exports__